import type { FacilityDetailsWithVideo } from 'src/components/facilities/facilities';
import React, { useContext } from 'react';
import { CmsContent } from 'src/content';
import { SiteContext } from 'src/context/site-context';
import FadedImage from 'src/components/common/faded-image';
import imageFade from 'src/helpers/image-fades';
import { borderRadius, colors } from 'src/styling/constants';
import VimeoVideo from 'src/components/common/vimeo-video';

const FacilityImage = ({
  facilityType,
  useSmallThumbnails,
  isNav,
}: {
  facilityType: FacilityDetailsWithVideo;
  useSmallThumbnails: boolean;
  isNav?: boolean;
}) => {
  const cmsData = useContext(CmsContent);
  const navigationContent = cmsData.navigationMenuContent.navigation!;
  const { styling, isHarbour, isDL } = useContext(SiteContext);
  const textElement = (
    <div className={`${useSmallThumbnails ? 'pa2' : 'pa2 pa4-l'} h-100 flex items-end`}>
      <div
        css={[
          isDL ? styling.fonts.regular : styling.fonts.bold,
          {
            color: 'white',
            textAlign: 'left',
            lineHeight: 1,
            fontSize: isDL && !isNav ? '1.6875rem' : undefined,
          },
        ]}
      >
        {facilityType.displayName}
      </div>
    </div>
  );
  const imageElement = (
    <FadedImage
      className={!isDL ? 'rounded' : ''}
      image={navigationContent?.[facilityType.cmsKey]}
      fadeType={imageFade.fadeDownwards}
      zoomOnHover
      style={
        isDL && {
          borderRadius: borderRadius.image.medium,
        }
      }
    >
      {textElement}
    </FadedImage>
  );

  const facilityVideo = facilityType.videoId;

  return (
    <div
      css={{
        borderLeft:
          isHarbour && !useSmallThumbnails ? `15px solid ${colors.harbourGold}` : undefined,
        height: '100%',
        width: '100%',
        position: 'relative',
      }}
    >
      {facilityVideo && !useSmallThumbnails ? (
        <>
          {facilityVideo ? (
            <VimeoVideo
              video={{
                videoId: facilityVideo,
                videoPlaceholder: navigationContent?.[facilityType.cmsKey],
              }}
              loop
              muted
              disableAutopause
            >
              {textElement}
            </VimeoVideo>
          ) : null}
        </>
      ) : (
        imageElement
      )}
    </div>
  );
};

export { FacilityImage };
